import '@riophae/vue-treeselect/dist/vue-treeselect.css';
import component from '@riophae/vue-treeselect';

export default {
	install(Vue){
		Vue.component('Treeselect', component)
	}
}
